import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import { RouteConfig } from '../shared/interfaces/routes-config.interface';
import { MyHrContainer } from './containers/my-hr/my-hr.container';

/**
 * HR self-service (Trello #699): leave, work-from-home and approvals, with Horilla as the only
 * record. One container, two paths: the tab is the URL, so "Approvals" can be linked to.
 */
export const HrModule: React.FC = () => {
  // Read at render time, never in a module-level const: see lead.module.tsx.
  const children = APP_ROUTES.HR_MODULE.CHILDREN as RouteConfig;

  return (
    <>
      <Route exact path={APP_ROUTES.HR_MODULE.FULL_PATH}>
        <Redirect to={children.REQUESTS.FULL_PATH} />
      </Route>
      <Route path={children.REQUESTS.FULL_PATH} component={MyHrContainer} />
      <Route path={children.APPROVALS.FULL_PATH} component={MyHrContainer} />
    </>
  );
};
